import * as Sentry from "@sentry/vue";

import { toast } from "./toast";

/**
 * Custom application error that can be thrown to interrupt normal execution flow and display an error message to the user using a toast notification.
 *
 * @class
 * @extends Error
 */
export class AppError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export function handleAppError(error: unknown): void {
  Sentry.captureException(error);

  if (error instanceof AppError || error instanceof APIError) {
    toast("error", error.message);
  } else {
    throw error;
  }
}

export class APIError extends Error {
  constructor(public response: { message: string }, public statusCode: number) {
    super(response.message);
  }
}

export class FormError extends Error {
  constructor(message: string, public properties: PropertyError[]) {
    super(message);
  }
}

interface PropertyError {
  property: string;
  errorMessages: string[];
}

export class ConflictError extends Error {
  constructor(message: string, public duplicateProperty: string) {
    super(message);
  }
}
